import { useLocation, Link } from "react-router-dom";
import classnames from "classnames";
import styles from "./UserManagementNavTabs.module.css";

export function UserManagementNavTabs() {
  const location = useLocation();

  const isGroupsActive =
    location.pathname === "/user-management/groups" ||
    location.pathname.startsWith("/user-management/groups/");
  const isUsersActive = !isGroupsActive;

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabList}>
        <Link
          to="/user-management"
          className={classnames(styles.tab, {
            [styles.activeTab]: isUsersActive,
          })}
        >
          Users
        </Link>
        <Link
          to="/user-management/groups"
          className={classnames(styles.tab, {
            [styles.activeTab]: isGroupsActive,
          })}
        >
          Groups
        </Link>
      </div>
    </div>
  );
}
